import React, { useState, useEffect, useRef } from 'react';

const PREFERENCE_OPTIONS = [
    { id: 'show_function_execution_given_set', label: 'Show Function Execution Using The Given Set' },
    { id: 'show_function_execution_green', label: 'Show Function Execution in Green' },
];

export default function WizardSelectGivenSetPreferencesForm({ countryData, detailsData, onDataChange, initialData }) {
    const [selectedPreferences, setSelectedPreferences] = useState(initialData.selectedPreferences || []);
    const onDataChangeRef = useRef(onDataChange);

    // Update ref when callback changes
    useEffect(() => {
        onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    // Only call onDataChange when actual data changes
    useEffect(() => {
        if (onDataChangeRef.current) {
            onDataChangeRef.current({ selectedPreferences });
        }
    }, [selectedPreferences]);

    const handlePreferenceToggle = (optionId) => {
        setSelectedPreferences(prev => {
            if (prev.includes(optionId)) {
                return prev.filter(id => id !== optionId);
            } else {
                return [...prev, optionId];
            }
        });
    };

    return (
        <div className="wizard-select-given-set-preferences-form">
            <h2 className="wizard-step-heading">Select The Given Set Preferences</h2>

            <div className="preferences-container">
                <div className="preferences-options-list">
                    {PREFERENCE_OPTIONS.map((option) => (
                        <div
                            key={option.id}
                            className={`preference-option checkbox ${selectedPreferences.includes(option.id) ? 'selected' : ''}`}
                            onClick={() => handlePreferenceToggle(option.id)}
                        >
                            <div className="preference-option-content">
                                <span className="preference-option-label">{option.label}</span>
                                <div className={`preference-option-checkbox ${selectedPreferences.includes(option.id) ? 'checked' : ''}`}>
                                    {selectedPreferences.includes(option.id) && (
                                        <svg viewBox="0 0 24 24" className="checkbox-icon">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
